import { ReactNode, SVGProps, forwardRef } from 'react';

interface ChartMargin {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

interface ChartContext {
  innerWidth: number;
  innerHeight: number;
}

interface ChartLayoutProps extends Omit<SVGProps<SVGSVGElement>, 'children'> {
  width: number;
  height: number;
  margin: ChartMargin;
  children: (ctx: ChartContext) => ReactNode;
}

const ChartLayout = forwardRef<SVGSVGElement, ChartLayoutProps>(
  ({ width, height, margin, children, ...props }, ref) => {
    const innerWidth = Math.max(0, width - margin.left - margin.right);
    const innerHeight = Math.max(0, height - margin.top - margin.bottom);

    const ctx: ChartContext = {
      innerWidth,
      innerHeight,
    };

    return (
      <svg viewBox={`0 0 ${width} ${height}`} {...props}>
        <g ref={ref} transform={`translate(${margin.left},${margin.top})`}>
          {children(ctx)}
        </g>
      </svg>
    );
  }
);

export { ChartLayout };
